import { TroubleshootingTool } from "./troubleshooting-tools.types";
import { DocumentAnalyzer } from "./tools/document-analyzer/DocumentAnalyzer";
import { DocPartCCLinker } from "./tools/docpart-cc-linker/DocPartCCLinker";
import { PerformanceLogs } from "./tools/performance-logs/PerformanceLogs";
import { SseTest } from "./tools/sse-test/SseTest";

/**
 * Tools registry
 *
 * How to add a new tool:
 * 1. Create the new component in ./tools/
 * 2. Import here
 * 3. Add to the array TROUBLESHOOTING_TOOLS
 */

export const TROUBLESHOOTING_TOOLS: TroubleshootingTool[] = [
  {
    id: "content-control-analyzer",
    name: "cof.troubleshooting.tools.documentanalyzer.name",
    description: "cof.troubleshooting.tools.documentanalyzer.description",
    icon: "DocumentSearch",
    component: DocumentAnalyzer,
  },
  {
    id: "docpart-cc-linker",
    name: "cof.troubleshooting.tools.docpartlinker.name",
    description: "cof.troubleshooting.tools.docpartlinker.description",
    icon: "Link",
    component: DocPartCCLinker,
  },

  {
    id: "performance-logs",
    name: "cof.troubleshooting.tools.performancelogs.name",
    description: "cof.troubleshooting.tools.performancelogs.description",
    icon: "Stopwatch",
    component: PerformanceLogs,
  },

  {
    id: "sse-test",
    name: "SSE channel test",
    description:
      "Verify the Server-Sent Events channel against network idle/read/first-byte timeouts and response buffering.",
    icon: "PlugConnected",
    component: SseTest,
  },

  // ADD NEW TOOLS HERE!!!
  // {
  //   id: "tool-test",
  //   name: "TEST",
  //   description: "TESTE",
  //   icon: "Test",
  //   component: TestTool,
  // },
];
